import React from 'react'

import styles from './styles.module.css'

export default function ({ children }){
    return (
        <div className="row">
            <div className="col text-center">
                <h1 className={styles.title}>{ children }</h1>
            </div>
        </div>
    )
}